import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RecalibrateContentProgressMutationVariables = Types.Exact<{
  entityId: Types.Scalars['String']['input'];
}>;


export type RecalibrateContentProgressMutation = { recalibrateContentProgress: { success?: boolean | null } };


export const RecalibrateContentProgressDocument = /*#__PURE__*/ gql`
    mutation recalibrateContentProgress($entityId: String!) {
  recalibrateContentProgress(input: {entityId: $entityId}) {
    success
  }
}
    `;

export function useRecalibrateContentProgressMutation() {
  return Urql.useMutation<RecalibrateContentProgressMutation, RecalibrateContentProgressMutationVariables>(RecalibrateContentProgressDocument);
};